import React, { useMemo } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Styles from './Styles.module.scss';

export const PrivacyApp: React.FC = () => {
  const { t } = useTranslation();

  const statementBlocks = t('DataProtectionStatementPage.StatementTextBlocks', {
    returnObjects: true,
  });

  const components: { readonly [tagName: string]: React.ReactElement } = useMemo(() => {
    return {
      text: <span className={Styles.text} />,
      u: <span className={`${Styles.text} ${Styles.underlineText}`} />,
      bold: <strong className={Styles.header} />,
      a: <a className={Styles.underlineText} />,
      header: <h2 className={Styles.header} />,
      li: <li className={Styles.text} />,
    };
  }, []);

  return (
    <div>
      <div className={Styles.container}>
        <h1 className={Styles.title}>{t('DataProtectionStatementPage.Title')}</h1>
        <p className={Styles.text}>{t('DataProtectionStatementPage.Subtitle')}</p>

        <div>
          {statementBlocks.map((block: any[], i: number) => (
            <div className={Styles.text} key={i}>
              {block.map((text: string, blockNumber: number) => (
                <Trans
                  className={Styles.distance}
                  parent="div"
                  components={components}
                  key={`blockNumber${blockNumber}`}
                >
                  {text}
                </Trans>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
